import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { QuotationSummaryData } from '../../models/quotations/Quotations';

const QUOTES_URL = '/api/v1/offers/summary';

const useQuotationSummarySWR = (quoteId: string) => {
    const fetch = (query): Promise<QuotationSummaryData> => {
        return httpApi
            .get<{ offer_summary: QuotationSummaryData }>(query)
            .then((res) => {
                return res.getData().offer_summary;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        QUOTES_URL + '/' + quoteId,
        fetch,
        {
            // dedupingInterval: 600000, // 10min
            errorRetryCount: 1,
            // revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
        }
    );

    return {
        quote: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useQuotationSummarySWR;
